import { render, staticRenderFns } from "./ClientHeader.vue?vue&type=template&id=16683b67&scoped=true&"
import script from "./ClientHeader.vue?vue&type=script&lang=js&"
export * from "./ClientHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16683b67",
  null
  
)

export default component.exports